export default "__VITE_ASSET__29e2edc3__"